import { render, staticRenderFns } from "./AggregationTableCell.vue?vue&type=template&id=61c6d30e&scoped=true&"
import script from "./AggregationTableCell.vue?vue&type=script&lang=js&"
export * from "./AggregationTableCell.vue?vue&type=script&lang=js&"
import style0 from "./AggregationTableCell.vue?vue&type=style&index=0&id=61c6d30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c6d30e",
  null
  
)

export default component.exports